import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "startsWithFilter",
  pure: false,
})
export class StartsWithFilterPipe implements PipeTransform {
  transform(options: any[], searchText: string): any[] {
    if (searchText === undefined || searchText === null || searchText === "")
      return options;
    if (searchText === " ") return [];
    searchText = searchText?.toLowerCase();

    return options
      .filter((option) => option?.key?.toLowerCase()?.includes(searchText))
      .sort((a, b) => {
        const aStarts = a?.key?.toLowerCase()?.startsWith(searchText) ? 0 : 1;
        const bStarts = b?.key?.toLowerCase()?.startsWith(searchText) ? 0 : 1;
        return aStarts - bStarts;
      });
  }
}
